import React from 'react';
import styled from 'styled-components';
import { useProjectElementListStore } from '../../../shared/store/projectElementStore';
import { DisplayAlignment, DisplaySize } from '../../../shared/enum/EnumRepository';
import { DocumentData } from '../../../shared/dto/EntityRepository';
import { StyledImgProps } from '../../../shared/dto/StyleCompRepository';
import { convertS3UrlToCloudFrontUrl } from '../../../shared/aws/awsHelper';
import OptimizedMoleculeImg from '../../../shared/component/molecule/OptimizedMoleculeImg';
import { useEditMode } from '../../../shared/hooks/useEditMode';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import HintWrapper from '../../../shared/component/headless/button/HintWrapper';
import { getHintMessage } from '../../../shared/constants/hintMessages';
import videoIcon from '../../../asset/icon/video.png';

export interface DocumentImgInPeMobileProps {
  peId: string;
  alignment: DisplayAlignment;
  displaySize: DisplaySize;
  data: DocumentData;
  priority: boolean;
  onChangeType?: () => void;
}

const DocumentImgInPeMobile: React.FC<DocumentImgInPeMobileProps> = ({ peId, alignment, displaySize, data, priority, onChangeType }) => {
  const { isEditMode } = useEditMode();
  const handleImageChange = useProjectElementListStore((s) => s.updateImage);

  const convertedCloudFrontUrl = convertS3UrlToCloudFrontUrl(data.uploadFile.originUrl);

  return (
    <ImgInPeWrapper>
      <OptimizedMoleculeImg
        srcUrl={convertedCloudFrontUrl}
        alt={data.description}
        displaySize={displaySize || DisplaySize.REGULAR}
        displayAlignment={alignment || DisplayAlignment.CENTER}
        handleChange={(originUrl: string, width: number, height: number) =>
          handleImageChange(
            peId,
            originUrl,
            width,
            height
          )}
        StyledImg={WorkImageForLandscape as React.ComponentType<StyledImgProps>}
        priority={priority}
      />
      {isEditMode && onChangeType && (
        <EditTransparentLayer>
          <EditBtnContainer>
            <HintWrapper
              content={getHintMessage('CHANGE_DETAIL_TYPE', { detailType: 'Video' })}
              toLeft={true}
            >
              <UniversalIconBtn
                size="fit"
                border={true}
                backgroundImg={videoIcon}
                onClick={onChangeType}
              />
            </HintWrapper>
          </EditBtnContainer>
        </EditTransparentLayer>
      )}
    </ImgInPeWrapper>
  );
};

const EditTransparentLayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: linear-gradient(to right, transparent 50%, ${({ theme }) => theme.colors.color_Gray_06} 150%);
  backdrop-filter: blur(0px);
  &:hover {
    opacity: 1;
    backdrop-filter: blur(2px);
  }
  transition: all 0.6s ease-in-out;
  cursor: default;
`;

const EditBtnContainer = styled.div`
  position: absolute;
  right: 0.5vh;
  top: 0.5vh;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5vh;
`;

const ImgInPeWrapper = styled.div`
  margin: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 0;
`;

const WorkImageForLandscape = styled.img<{ $displaySize: DisplaySize }>`
  width: ${({ $displaySize }) => {
    switch ($displaySize) {
      case DisplaySize.SMALL:
      case DisplaySize.REGULAR:
      case DisplaySize.MEDIUM:
      case DisplaySize.BIG:
        return '90vw';
      case DisplaySize.WIDE:
      default:
        return '100vw';
    }
  }};
  transition: width 0.6s ease;
  object-fit: contain;
`;

export default DocumentImgInPeMobile;

